/* eslint-disable jsx-a11y/anchor-is-valid */
/** @format */

import moment from "dayjs";
import { useHistory } from "../../router/useHistory";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { TEXT_DIRECTION, canAccessTheModule } from "../../helper/helperFunctions";
import I18n, { i18n } from "../../pages/private/languageSelector";
import analyticsIcon from "../../assets/images/analyticsIcon.svg";
import formGrayIcon from "../../assets/images/company/FormsGrayIcon.svg";
import reportGrayIcon from "../../assets/images/company/ReportsGrayIcon.svg";
import companyIcon from "../../assets/images/companyIcon.svg";
import dropdown from "../../assets/images/customDropdown.svg";
import formsIcon from "../../assets/images/formsIcon.svg";
import reportIcon from "../../assets/images/reportsIcon.svg";
import userIcon from "../../assets/images/userIcon.svg";
import ChargeBillingDetails from "../../pages/private/management/company/subscriptions/charge-billing-details";
import NotificationsDialog from "../../pages/private/notifications/notificationsDialog";
import { changeCurrentRole, getSession, logout } from "../../redux/reducers/authentication/authentication";
import { getForm, getForms, patchForm, patchFormForNotification } from "../../redux/reducers/form/form.reducer";
import { getAllNotifications, notificationMarkedAsRead, notificationReadSingle } from "../../redux/reducers/notifications/notifications.reducer";
import { getSubscriptionByCompanyId, updateSubscriptionData } from "../../redux/reducers/subscription/subscription.reducer";
import Dialog from "../dialogs/Dialog";
import PlanDialog from "../dialogs/PlanDialog";
import PremiumFeatureDialog from "../dialogs/PremiumFeatureDialog";
import PricingPlanDialog from "../dialogs/PricingPlanDialog";

const AppHeader = ({
  user,
  logout,
  rolesAccess,
  currentRole,
  currentRoute,
  patchForm,
  patchFormForNotification,
  isAuthenticated,
  allNotifications,
  collapsed,
  setCollapsed,
  getAllNotifications,
  notificationReadSingle,
  notificationMarkedAsRead,
  storedOldForm,
  id,
  newForm,
  subscriptionData,
  updateSubscriptionData,
  getSubscriptionByCompanyId,
  getSession,
  openNotification,
  setOpenNotification,
  unreadCount,
}) => {
  let wrapperRef = useRef();
  const history = useHistory();

  const toggleNavbar = () => {
    if (currentRoute?.enableBack) {
      if (currentRoute.step2 === "Form Management") {
        history.push("/forms/form-management");
      } else if (currentRoute.step2 === "Global List") {
        history.push("/forms/global-list");
      }
    }
  };
  const location = useLocation();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [formDropdownOpen, setFormDropdownOpen] = useState(false);
  const [reportDropdownOpen, setReportDropdownOpen] = useState(false);
  const [companyDropdownOpen, setComapnyDropdownOpen] = useState(false);

  const [reportsPopoverOpen, setReportsPopoverOpen] = useState(false);
  const [formsPopoverOpen, setFormsPopoverOpen] = useState(false);
  const [companyPopoverOpen, setCompanyPopoverOpen] = useState(false);
  const [userPopoverOpen, setUserPopoverOpen] = useState(false);

  const toggleFormsPopover = () => {
    setFormsPopoverOpen((prevState) => !prevState);
    setReportsPopoverOpen(false);
    setCompanyPopoverOpen(false);
  };

  const toggleReportsPopover = () => {
    setReportsPopoverOpen((prevState) => !prevState);
    setFormsPopoverOpen(false);
    setCompanyPopoverOpen(false);
  };
  const toggleCompanyPopover = () => {
    setCompanyPopoverOpen((prevState) => !prevState);
    setReportsPopoverOpen(false);
    setFormsPopoverOpen(false);
  };
  const toggleUserPopover = () => {
    setUserPopoverOpen((prevState) => !prevState);
    setCompanyPopoverOpen(false);
    setReportsPopoverOpen(false);
    setFormsPopoverOpen(false);
  };

  const toggle = () => {
    setDropdownOpen((prevState) => !prevState);
    setFormDropdownOpen(false);
    setReportDropdownOpen(false);
    setComapnyDropdownOpen(false);
  };

  const toggleForm = () => {
    setFormDropdownOpen((prevState) => !prevState);
    setDropdownOpen(false);
    setReportDropdownOpen(false);
    setComapnyDropdownOpen(false);
  };

  const toggleReport = () => {
    setReportDropdownOpen((prevState) => !prevState);
    setDropdownOpen(false);
    setFormDropdownOpen(false);
    setComapnyDropdownOpen(false);
  };

  const toggleCompany = () => {
    setComapnyDropdownOpen((prevState) => !prevState);
    setDropdownOpen(false);
    setFormDropdownOpen(false);
    setReportDropdownOpen(false);
  };

  const [, setUnReadNotification] = useState([]);
  const [modalData] = useState(null);
  const [showUpdatePlanModal, setShowUpdatePlanModal] = useState(false);
  const [showUpdateSuccessModal, setShowUpdateSuccessModal] = useState(false);
  const [trialDate, setTrialDate] = useState(null);
  const [, setShowDetailsDialog] = useState(false);
  const [showPricingPlanModal, setShowPricingPlanModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [chargeBillingDetailsDailog, setChargeBillingDetailsDailog] = useState(false);
  const [showResumeSubscriptionModal, setShowResumeSubscriptionModal] = useState(false);
  const [showAnalyticsUpgrade, setShowAnalyticsUpgrade] = useState(false);
  const popoverRef = useRef(null);

  const closeUpdatePlanModal = () => {
    setShowUpdatePlanModal(false);
  };

  useEffect(() => {
    if (user?.company) {
      getSubscriptionByCompanyId(user?.company?.id);
    }
  }, [user?.company?.id]);

  const startTrialData = {
    currentPlan: {
      plan: "Trial",
      status: "Running",
      seats: subscriptionData?.seats?.used,
      price: 0,
    },
    seats: {
      used: subscriptionData?.seats?.used,
      available: 0,
      total: subscriptionData?.seats?.used,
    },
    userTrial: {
      isTrialStarted: true,
      isTrialCancelled: false,
      isTrialExpired: false,
    },
  };

  const StartFreeTrialHandler = async () => {
    const responseData = await updateSubscriptionData(subscriptionData?.id, startTrialData, "Update");
    setTrialDate(responseData?.value?.data?.trialEndedAt);
    setShowUpdatePlanModal(false);
    setShowUpdateSuccessModal(true);
  };

  // Analytics upgrade-modal handlers: defer the actual trial-start / plan-pick
  // to the subscriptions page so we reuse its existing handlers verbatim
  // (StartFreeTrialHandler + PricingPlanDialog cascade) rather than spawning
  // a parallel implementation here.
  const handleStartTrialFromAnalytics = () => {
    sessionStorage.setItem("pendingStartTrial", "true");
    setShowAnalyticsUpgrade(false);
    history.push("/management/subscriptions");
  };

  const handleSubscribeFromAnalytics = () => {
    sessionStorage.setItem("pendingOpenPricingPlan", "true");
    setShowAnalyticsUpgrade(false);
    history.push("/management/subscriptions");
    // Dispatch on the next tick so SubscriptionsView has time to mount
    // (when navigating from a different route). When already on the
    // subscriptions route, history.push is a no-op and the listener is
    // already attached — the event fires immediately and bumps the
    // consumer-useEffect tick so it picks up the just-written flag.
    // Without this event, push-to-same-path silently drops the open.
    setTimeout(() => {
      try { window.dispatchEvent(new CustomEvent("openPricingPlanFromAnalytics")); } catch (_) { /* CustomEvent unavailable */ }
    }, 0);
  };

  useEffect(() => {
    if (!isAuthenticated || !user) {
      setCollapsed(true);
    }
    // eslint-disable-next-line
  }, [isAuthenticated, user]);

  const markedReadSingleHandler = (id) => {
    if (id) {
      notificationReadSingle(id, { isRead: true }).then(() => {
        getAllNotifications();
      });
    }
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (popoverRef.current && !popoverRef.current.contains(e.target)) {
        setFormsPopoverOpen(false);
        setReportsPopoverOpen(false);
        setCompanyPopoverOpen(false);
        setUserPopoverOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const markedAsReadHandle = () => {
    notificationMarkedAsRead().then(() => getAllNotifications());
  };

  useEffect(() => {
    let unreadArray = [];
    if (allNotifications && allNotifications.length) {
      unreadArray = allNotifications.filter((item) => !item.isRead).map((item) => item);
    }
    setUnReadNotification([...unreadArray]);
  }, [allNotifications]);

  let language = user?.language;

  const formattedTrialEndDate = moment(trialDate).format("DD MMM YYYY");

  const updatePlanData = {
    title: <I18n lng="Subscriptions.UpdatePlanTrialStartedModalTitle" />,
    text_one: (
      <>
        <I18n lng="Subscriptions.YourTrialHasStartedSuccessfully" /> {formattedTrialEndDate}
      </>
    ),
    closeButtonText: <I18n lng="global.Close" />,
    actionButtonText: i18n("global.UpdatePlan"),
  };

  const pricingPlanModalData = {
    title: <I18n lng="Subscriptions.SelectYourPricingPlan" />,
    text_one: <I18n lng="Subscriptions.PriceIsExclusiveOfTaxes" />,
    text_two: <I18n lng="Subscriptions.YouWillBeChargedAutomaticallyAtThe" />,
    actionButtonText: <I18n lng="Subscriptions.Continue" />,
    closeButtonText: <I18n lng="global.Cancel" />,
  };

  const isRTL = TEXT_DIRECTION() === "rtl";

  const resumeSubscriptionModalData = {
    title: <I18n lng="Subscriptions.ResumesSubscription" />,
    text_one: i18n("Subscriptions.ClickResumeSubscriptionToConfirmYourDesireToContinueAccessingAllFeaturesBenefits"),
    actionButtonText: i18n("Subscriptions.ResumesSubscription"),
    closeButtonText: <I18n lng="global.Close" />,
  };

  const isTrialExpired = subscriptionData?.userTrial?.isTrialExpired && subscriptionData?.currentPlan?.status === "Expired";
  const isSubscriptionPaused = subscriptionData?.currentPlan?.status === "Paused";

  const path =
    location.pathname.includes("/management/users/") ||
    location.pathname.includes("/report-pdf-view") ||
    location.pathname.includes("/management/subscriptions/update-plan") ||
    location.pathname.includes("/management/sites/add") ||
    location.pathname.includes("/reports/my-reports/edit/") ||
    location.pathname.includes("/start/") ||
    location.pathname.includes("/homepage") ||
    location.pathname.includes("/terms-and-conditions") ||
    location.pathname.includes("/privacy-policy") ||
    location.pathname.includes("setup-account") ||
    location.pathname.includes("/password-reset-message-email") ||
    location.pathname.includes("/management/sites/") ||
    location.pathname.includes("/forms/form-management/dispatch/") ||
    (currentRoute?.step1 === undefined && location.pathname.includes("/forms/form-management")) ||
    currentRoute?.enableBack;

  const resumeSubscriptionData = {
    currentPlan: {
      plan: subscriptionData?.currentPlan?.plan,
      status: "Running",
      seats: subscriptionData?.currentPlan?.seats,
      price: subscriptionData?.currentPlan?.price,
    },
    seats: {
      used: subscriptionData?.seats?.used > 10 ? 1 : subscriptionData?.seats?.used,
      available: subscriptionData?.seats?.used > 10 ? 9 : 10 - subscriptionData?.seats?.used,
      total: 10,
    },
    userTrial: {
      isTrialStarted: false,
      isTrialCancelled: true,
      isTrialExpired: true,
    },
    subscriptionInfo: {
      isSubscribed: true,
      isUnsubscribed: false,
      isSubscribeResumed: false,
      isSubscribedExpired: false,
    },
  };

  const hanldeResumeSubscription = async () => {
    await updateSubscriptionData(subscriptionData?.id, resumeSubscriptionData, "Update");
    setShowResumeSubscriptionModal(false);
    await getSubscriptionByCompanyId(user?.company?.id);
  };
  let companySettingAccess = user && user?.roleSetting?.managerPortal[2]?.subItem;
  let companySubItemAccess = {
    sites: companySettingAccess && companySettingAccess[0]?.selected,
    users: companySettingAccess && companySettingAccess[1]?.selected,
    roles: companySettingAccess && companySettingAccess[2]?.selected,
    information: companySettingAccess && companySettingAccess[3]?.selected,
    subscription: companySettingAccess && companySettingAccess[4]?.selected,
  };

  const canUserAccessTab = (text) => {
    if (companySubItemAccess[text]) {
      return true;
    } else {
      return false;
    }
  };

  const formsPopoverContent = (
    <div
      ref={popoverRef}
      className={`absolute bg-background w-[200px] ${currentRole === "user" ? "h-20" : "h-[13rem]"
        } flex flex-col gap-6 p-4 shadow-customReport cursor-pointer font-normal text-sm text-start top-1/2 -translate-y-1/2 ${isRTL ? "right-full mr-3" : "left-full ml-3"
        } z-50`}
    >
      <>
        <div
          className={`text-sm ${isTrialExpired ? "text-colGrayLight cursor-default" : "cursor-pointer"}`}
          onClick={(e) => {
            e.preventDefault();
            setFormsPopoverOpen(false);
            history.push("/forms/form-management");
          }}
        >
          {language === "ARABIC" ? (
            <span>
              {/* {i18n("Form.NewList")} {i18n("global.Forms")}{" "} */}
              {i18n("Form.Forms-List")}
            </span>
          ) : (
            <span>
              {/* {i18n("global.Forms")} {i18n("Form.NewList")} */}
              {i18n("Form.Forms-List")}
            </span>
          )}
        </div>

        {currentRole !== "user" && (
          <div
            className={`text-sm ${isTrialExpired ? "text-colGrayLight cursor-default" : "cursor-pointer"}`}
            onClick={(e) => {
              e.preventDefault();
              setFormsPopoverOpen(false);
              history.push("/forms/global-list");
            }}
          >
            <span>{i18n("Form.Responses")}</span>
          </div>
        )}

        {currentRole !== "user" && (
          <div
            className={`text-sm ${isTrialExpired ? "text-colGrayLight cursor-default" : "cursor-pointer"}`}
            onClick={(e) => {
              e.preventDefault();
              setFormsPopoverOpen(false);
              history.push("/forms/archive");
            }}
          >
            {language === "ARABIC" ? <span>{i18n("Forms.Archive")}</span> : <span>{i18n("Forms.Archive")}</span>}
          </div>
        )}
        <div
          className={`text-sm ${isTrialExpired ? "text-colGrayLight cursor-default" : "cursor-pointer"}`}
          onClick={(e) => {
            e.preventDefault();
            setFormsPopoverOpen(false);
            history.push("/forms/library");
          }}
        >

          <span>

            <I18n lng="global.Library" />
          </span>

        </div>
      </>
    </div>
  );

  const reportsPopoverContent = (
    <div
      ref={popoverRef}
      className={`absolute bg-background w-[200px] h-40 flex flex-col gap-6 p-4 shadow-customReport shadow-custom cursor-pointer font-normal text-sm text-start top-1/2 -translate-y-1/2 ${isRTL ? "right-full mr-3" : "left-full ml-3"
        } z-50`}
    >
      <div
        className={`text-sm ${isTrialExpired ? "text-colGrayLight cursor-default" : "cursor-pointer"}`}
        onClick={() => {
          history.push("/reports/my-reports");
          setReportsPopoverOpen(false);
        }}
      >
        {/* {i18n("Reports.My-Reports")} */}
        {i18n("Reports.Inspections")}
      </div>
      <div
        className={`text-sm ${isTrialExpired ? "text-colGrayLight cursor-default" : "cursor-pointer"}`}
        onClick={() => {
          history.push("/reports/other-reports");
          setReportsPopoverOpen(false);
        }}
      >
        {i18n("Reports.OtherReports")}
      </div>
      <div
        className={`text-sm ${isTrialExpired ? "text-colGrayLight cursor-default" : "cursor-pointer"}`}
        onClick={() => {
          history.push("/reports/archive");
          setReportsPopoverOpen(false);
        }}
      >
        {i18n("Reports.Archive")}
      </div>
    </div>
  );

  const companyPopoverContent = (
    <div
      ref={popoverRef}
      className={`absolute bg-background w-[200px] h-[260px] flex flex-col gap-6 p-4 shadow-customReport shadow-custom cursor-pointer font-normal text-sm text-start
        top-1/2 -translate-y-1/2 ${isRTL ? "right-full mr-3" : "left-full ml-3"} z-50`}
    >
      <>
        <div style={isTrialExpired || isSubscriptionPaused ? { pointerEvents: "none" } : {}}
          className="text-colLightGray text-sm font-normal"
          onClick={(e) => {
            e.preventDefault();
            setCompanyPopoverOpen(false);
            history.push("/management/info");
          }}
        >
          <span className={`text-sm ${isTrialExpired || isSubscriptionPaused ? "text-colGrayLight cursor-default" : "cursor-pointer"}`}>
            {i18n("Company.Info")}
          </span>
        </div>

        <div
          className="text-colLightGray text-sm font-normal"
          onClick={(e) => {
            if (canUserAccessTab("users")) {
              e.preventDefault();
              setCompanyPopoverOpen(false);
              history.push("/management/users");
            }
          }}
        >
          {/* <span className="text-colLightGray text-sm font-normal">{i18n("Company.Users")}</span> */}
          <span className={`text-sm ${!canUserAccessTab("users") ? "text-colGrayLight cursor-default" : "cursor-pointer"}`}>
            {i18n("Company.Users")}
          </span>
        </div>
        <div style={isTrialExpired || isSubscriptionPaused ? { pointerEvents: "none" } : {}}
          className="text-colLightGray text-sm font-normal"
          onClick={(e) => {
            if (canUserAccessTab("roles")) {
              e.preventDefault();
              setCompanyPopoverOpen(false);
              history.push("/management/roles");
            }
          }}
        >
          <span className={`text-sm ${isTrialExpired || isSubscriptionPaused || !canUserAccessTab("roles") ? "text-colGrayLight cursor-default" : "cursor-pointer"}`}>
            {i18n("Company.Roles")}
          </span>
        </div>

        <div style={isTrialExpired || isSubscriptionPaused ? { pointerEvents: "none" } : {}}
          className="text-colLightGray text-sm font-normal"
          onClick={(e) => {
            if (canUserAccessTab("sites")) {
              e.preventDefault();
              setCompanyPopoverOpen(false);
              history.push("/management/sites");
            }
          }}
        >
          <span className={`text-sm ${isTrialExpired || isSubscriptionPaused || !canUserAccessTab("sites") ? "text-colGrayLight cursor-default" : "cursor-pointer"}`}>
            {i18n("Company.Sites")}
          </span>
        </div>
        <div
          className="text-colLightGray text-sm font-normal"
          onClick={(e) => {
            if (canUserAccessTab("subscription")) {
              e.preventDefault();
              setCompanyPopoverOpen(false);
              history.push("/management/subscriptions");
            }
          }}
        >
          <span className={`text-sm ${!canUserAccessTab("subscription") ? "text-colGrayLight cursor-default" : "cursor-pointer"}`}>
            {i18n("Table.Subscriptions")}
          </span>
        </div>
      </>
    </div>
  );

  const userPopoverContent = (
    <div
      ref={popoverRef}
      className={`absolute bg-background w-[200px] h-40 flex flex-col gap-6 p-4 shadow-customReport shadow-custom cursor-pointer font-normal text-sm text-start top-1/2 -translate-y-1/2 ${isRTL ? "right-full mr-3" : "left-full ml-3"
        } z-50`}
    >
      <div
        className="text-colLightGray text-sm font-normal"
        onClick={(e) => {
          history.push("/company-user-profile");
          setUserPopoverOpen(false);
        }}
      >
        <span>{i18n("global.Settings")}</span>
      </div>
      <div className="text-colLightGray text-sm font-normal cursor-pointer" onClick={() => window.open("https://help.tamamplus.com/help", "_blank")}>
        <span>{i18n("global.Help")}</span>
      </div>

      <div className="text-colLightGray text-sm font-normal cursor-pointer" onClick={() => setIsModalOpen(true)}>
        <span>{i18n("global.Logout")}</span>
      </div>
    </div>
  );

  return (
    <>
      {!path && (
        <header
          style={{
            direction: TEXT_DIRECTION(),
          }}
          className="!bg-[#FFFFFF] shadow-custom z-50"
          ref={wrapperRef}
        >
          <div className={`   ${collapsed ? "hidden" : ""} xl:inline lg:inline md:inline `} style={{ direction: TEXT_DIRECTION() }}>
            <nav
              className={`bg-background  transition-all ease-in-out duration-100  !border 200vh fixed w-[264px]  z-50 ${collapsed ? "!w-14" : "w-[264px]"
                }`}
              dir={TEXT_DIRECTION()}
            >
              {((user && isAuthenticated && user.isEmailVerified && user.company) ||
                (user && isAuthenticated && !user.isEmailVerified && user.company)) &&
                (currentRole === "admin" ||
                  (currentRole === "user" && !user.paymentPlan) ||
                  currentRole === "user" ||
                  (currentRole === "manager" && !user.paymentPlan) ? (
                  <div className={`7px] ${!collapsed ? "ml-1 p-6 pt-0 flex w-[264px] lg:inline xl:inline " : ""} `}>
                    <button onClick={toggleNavbar} className="focus:outline-none">
                      {currentRoute?.enableBack && (
                        <small style={{ marginLeft: "0.5rem" }}>
                          <div
                          // onClick={async () => {
                          //   try {
                          //     await patchForm(id, {
                          //       ...newForm,
                          //       isEditable:
                          //         localStorage.getItem("formState") ===
                          //         "forEdit",
                          //     });

                          //     await patchFormForNotification(id, {
                          //       oldForm: storedOldForm,
                          //       newForm: newForm,
                          //     });

                          //     localStorage.setItem("isEditOpen", null);

                          //     await getForms({
                          //       limit: 10,
                          //       page: 1,
                          //       sortBy: "updatedAt:desc",
                          //       isArchived: false,
                          //     });
                          //   } catch (error) {
                          //     console.error("Error updating form:", error);
                          //   }
                          // }}
                          >
                            <I18n lng="global.Save" /> <br />
                            <I18n lng="global.Back" />
                          </div>
                        </small>
                      )}
                    </button>
                  </div>
                ) : null)}

              <div
                dir={TEXT_DIRECTION()}
                className={`!px-0   ${collapsed ? "mini-header " : ""} ${TEXT_DIRECTION() === "rtl" ? "!right-0" : "!left-0"}`}
              >
                <div className="h-[100vh]">
                  <div>
                    <h4 className={`text-[#333333] text-xl font-normal !60px] mt-[70px] !ml-2 ${collapsed ? "!invisible" : "!visible"}`}>
                      {currentRole === "user" ? (
                        <span className={`ml-3 ${language === "ARABIC" && "flex mr-10"}`}>
                          <I18n lng="global.TamamApp" />{" "}
                        </span>
                      ) : currentRole === "manager" ? (
                        <I18n lng="Table.BackOffice" />
                      ) : (
                        <span className={`ml-3 ${language === "ARABIC" && "flex mr-10"}`}>
                          <I18n lng="Table.BackOffice" />
                        </span>
                      )}
                    </h4>{" "}
                  </div>
                  <hr className="!bg-[#E0E0E0]  w-full mt-[38px]" />
                  <nav className={`mt-[50px] ${collapsed ? "p-0" : "mx-2"} flex flex-col gap-5 p-6 pt-0`}>
                    <div style={(isTrialExpired || isSubscriptionPaused) ? { pointerEvents: "none" } : {}} className={`cursor-pointer ${window.location.href.indexOf("/forms/form-management") > -1 ? "active" : ""}`}>
                      {currentRole !== "user" ? (
                        canAccessTheModule(
                          rolesAccess?.form?.selected,
                          <>
                            <div>
                              {/*  */}
                              <div
                                className={`${isTrialExpired ? "pointer-events-none" : "cursor-pointer"} ${collapsed ? "flex justify-center" : ""} ${isTrialExpired ? "no-underline text-decoration-none" : "no-underline"
                                  }`}
                              >
                                {collapsed ? (
                                  <div className="min-h-[40px] flex items-center justify-center relative">
                                    <img
                                      src={isTrialExpired || isSubscriptionPaused ? formGrayIcon : formsIcon}
                                      alt="formIcon"
                                      className="w-5 h-5 cursor-pointer"

                                      onClick={toggleFormsPopover}
                                    />
                                    {formsPopoverOpen && formsPopoverContent}
                                  </div>
                                ) : (
                                  <div
                                    className={`${isTrialExpired ? "pointer-events-none" : "cursor-pointer"
                                      } flex items-center gap-3 text-center justify-center min-h-[40px]`}
                                  >
                                    <div>
                                      <img src={(isTrialExpired || isSubscriptionPaused) ? formGrayIcon : formsIcon} alt="formIcon" className={`w-5 h-5 `} />
                                    </div>
                                    <div className="flex text-center justify-between items-center w-full cursor-pointer" onClick={toggleForm}>
                                      <span className={`font-semibold text-sm ${(isTrialExpired || isSubscriptionPaused) && "text-colGrayLight"} `}>
                                        {!collapsed && i18n("Form.FormsPanel")}
                                      </span>
                                      <span>
                                        <img
                                          src={dropdown}
                                          alt="dropdown"
                                          className={`transition-transform duration-300 ${formDropdownOpen ? "rotate-180" : ""}`}
                                        />
                                      </span>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </>
                        )
                      ) : (
                        <div
                          className={`font-semibold text-sm ${collapsed ? "flex justify-center items-center min-h-[40px]" : "flex items-center justify-between gap-2 min-h-[40px]"
                            }`}
                          style={{
                            pointerEvents: isTrialExpired || isSubscriptionPaused ? "none" : "auto",
                            color: isTrialExpired || isSubscriptionPaused ? "#4D82AF" : "inherit",
                            textDecoration: isTrialExpired || isSubscriptionPaused ? "none" : "inherit",
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            history.push("/forms/form-management");
                          }}
                        >
                          <img src={formsIcon} alt="formIcon" className={`w-5 h-5`} />
                          <div className={`${!collapsed ? "flex justify-between items-center w-full" : ""}`}>
                            {/* <span>{!collapsed && i18n("global.Forms")}</span> */}
                            <span>{!collapsed && i18n("Form.FormsPanel")}</span>
                          </div>
                        </div>
                      )}
                      <div className="mx-7 ">
                        {formDropdownOpen && !collapsed && (
                          <div className="mt-3">
                            {currentRole !== "user" && (
                              <div
                                className={`text-colLightGray text-sm font-normal ${language === "ARABIC" && "text-start"}`}
                                onClick={(e) => {
                                  e.preventDefault();
                                  setCollapsed(true);
                                  history.push("/forms/form-management");
                                  setFormDropdownOpen(false);
                                }}
                              >
                                {language === "ARABIC" ? (
                                  <span className={`text-sm ${(isTrialExpired || isSubscriptionPaused) ? "text-colGrayLight cursor-default" : "cursor-pointer"}`}>
                                    {/* {i18n("Form.NewList")} {!collapsed && i18n("global.Forms")} */}
                                    {i18n("Form.Forms-List")}
                                  </span>
                                ) : (
                                  <span className={`text-sm ${(isTrialExpired || isSubscriptionPaused) ? "text-colGrayLight cursor-default" : "cursor-pointer"}`}>
                                    {/* {!collapsed && i18n("global.Forms")} {i18n("Form.NewList")}{" "} */}
                                    {i18n("Form.Forms-List")}
                                  </span>
                                )}
                              </div>
                            )}

                            <div
                              className={`text-colLightGray text-sm font-normal my-4 ${language === "ARABIC" && "text-start"}`}
                              onClick={(e) => {
                                e.preventDefault();
                                setCollapsed(true);
                                setFormDropdownOpen(false);
                                history.push("/forms/global-list");
                              }}
                            >
                              <span className={`text-sm ${isTrialExpired ? "text-colGrayLight cursor-default" : "cursor-pointer"}`}>
                                {i18n("Form.Responses")}
                              </span>
                            </div>

                            <div
                              className={`text-colLightGray text-sm font-normal ${language === "ARABIC" && "text-start"}`}
                              onClick={(e) => {
                                e.preventDefault();
                                setCollapsed(true);
                                setFormDropdownOpen(false);
                                history.push("/forms/archive");
                              }}
                            >
                              <span className={`text-sm ${isTrialExpired ? "text-colGrayLight cursor-default" : "cursor-pointer"}`}>
                                {i18n("Reports.Archive")}
                              </span>
                            </div>
                            <div
                              className={`text-colLightGray text-sm font-normal mt-4 ${language === "ARABIC" && "text-start"}`}
                              onClick={(e) => {
                                e.preventDefault();
                                setCollapsed(true);
                                history.push("/forms/library");
                                setFormDropdownOpen(false);
                              }}
                            >
                              <span>

                                <I18n lng="global.Library" />
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div style={(isTrialExpired || isSubscriptionPaused) ? { pointerEvents: "none" } : {}}
                      className={` ${window.location.href.indexOf("/reports") > -1 ? "active" : ""
                        }`}
                    >
                      {currentRole !== "user"
                        ? canAccessTheModule(
                          rolesAccess?.report?.selected,
                          <div className={`${collapsed ? "flex justify-center" : ""} ${isTrialExpired ? "no-underline text-decoration-none" : ""}`}>
                            <div className="flex text-center gap-2 items-center justify-center w-[100%] min-h-[40px] relative">
                              <img
                                src={(isTrialExpired || isSubscriptionPaused) ? reportGrayIcon : reportIcon}
                                alt="reports icon"
                                className="cursor-pointer"
                                style={{ minWidth: 20, minHeight: 20 }}
                                onClick={toggleReportsPopover}
                              />
                              {!collapsed && (
                                <div className="flex justify-between items-center w-[100%] cursor-pointer" onClick={toggleReport}>
                                  <span className={`font-semibold text-sm ${(isTrialExpired || isSubscriptionPaused) && "text-colGrayLight"}`}>
                                    {i18n("Reports.ReportsPanel")}
                                  </span>
                                  <span>
                                    <img
                                      src={dropdown}
                                      alt="dropdown"
                                      className={`transition-transform duration-300 ${reportDropdownOpen ? "rotate-180" : ""}`}
                                    />
                                  </span>
                                </div>
                              )}
                              {collapsed && reportsPopoverOpen && reportsPopoverContent}
                            </div>
                          </div>
                        )
                        : canAccessTheModule(
                          rolesAccess?.inspector?.accessReports,
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              setCollapsed(true);
                              history.push("/reports/my-reports");
                            }}
                            // to='/reports/my-reports'
                            className={` ${collapsed ? "flex justify-center items-center min-h-[40px]" : "flex items-center justify-between gap-2 min-h-[40px]"
                              }`}
                            style={{
                              pointerEvents: isTrialExpired || isSubscriptionPaused ? "none" : "auto",
                              color: isTrialExpired || isSubscriptionPaused ? "#4D82AF" : "inherit",
                              textDecoration: isTrialExpired || isSubscriptionPaused ? "none" : "inherit",
                            }}
                          >
                            <img src={reportIcon} alt="reports icon" className={`w-5 h-5`} />
                            {!collapsed && (
                              <div className="flex justify-between items-center w-full">
                                <span className="font-semibold text-sm">{i18n("Reports.ReportsPanel")}</span>
                              </div>
                            )}
                          </div>
                        )}
                      <div className="mx-7">
                        {reportDropdownOpen && !collapsed && (
                          <div className="mt-3">
                            {currentRole !== "user" && (
                              <div
                                className={`text-colLightGray text-sm font-normal ${language === "ARABIC" && "text-start"}`}
                                onClick={(e) => {
                                  e.preventDefault();
                                  setCollapsed(true);
                                  history.push("/reports/my-reports");
                                  setReportDropdownOpen(false);
                                }}
                              >
                                <span className={`text-sm ${isTrialExpired ? "text-colGrayLight cursor-default" : "cursor-pointer"}`}>
                                  {/* {!collapsed && i18n("Reports.My-Reports")} */}
                                  {!collapsed && i18n("Reports.Inspections")}
                                </span>
                              </div>
                            )}

                            <div
                              className={`text-colLightGray text-sm font-normal my-4 ${language === "ARABIC" && "text-start"}`}
                              onClick={(e) => {
                                e.preventDefault();
                                setCollapsed(true);
                                setReportDropdownOpen(false);
                                history.push("/reports/other-reports");
                              }}
                            >
                              <span className={`text-sm ${isTrialExpired ? "text-colGrayLight cursor-default" : "cursor-pointer"}`}>
                                {i18n("Reports.OtherReports")}
                              </span>
                            </div>

                            <div
                              className={`text-colLightGray text-sm font-normal ${language === "ARABIC" && "text-start"}`}
                              onClick={(e) => {
                                e.preventDefault();
                                setCollapsed(true);
                                setReportDropdownOpen(false);
                                history.push("/reports/archive");
                              }}
                            >
                              <span className={`text-sm ${isTrialExpired ? "text-colGrayLight cursor-default" : "cursor-pointer"}`}>
                                {i18n("Reports.Archive")}
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    {currentRole !== "user" ? (
                      <div className={`cursor-pointer ${window.location.href.indexOf("/management/info") > -1 ? "active" : ""}`}>
                        {canAccessTheModule(
                          rolesAccess?.company?.selected,
                          <div style={{ textDecoration: "none" }}>
                            <div className="flex text-center gap-2 items-center justify-center w-[100%] min-h-[40px] relative">
                              <img
                                src={companyIcon}
                                alt="IconCompanySetting"
                                className="cursor-pointer"
                                style={{ minWidth: 20, minHeight: 20 }}
                                onClick={toggleCompanyPopover}
                              />
                              {!collapsed && (
                                <div onClick={toggleCompany} className="flex justify-between items-center w-[100%] cursor-pointer">
                                  <span className="font-semibold text-sm">{i18n("Company.CompanySetting")}</span>
                                  <span>
                                    <img
                                      src={dropdown}
                                      alt="dropdown"
                                      className={`transition-transform duration-300 ${companyDropdownOpen ? "rotate-180" : ""}`}
                                    />
                                  </span>
                                </div>
                              )}
                              {collapsed && companyPopoverOpen && companyPopoverContent}
                            </div>
                          </div>
                        )}
                        <div className="mx-7">
                          {companyDropdownOpen && !collapsed && (
                            <div className="mt-3">
                              {currentRole !== "user" && (
                                <>
                                  <div style={isTrialExpired || isSubscriptionPaused ? { pointerEvents: "none" } : {}}
                                    className={`text-colLightGray text-sm font-normal ${language === "ARABIC" && "text-start"}`}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setComapnyDropdownOpen(false);
                                      setCollapsed(true);
                                      history.push("/management/info");
                                    }}
                                  >
                                    <span
                                      className={`text-sm ${isTrialExpired || isSubscriptionPaused ? "text-colGrayLight cursor-default" : "cursor-pointer"
                                        }`}
                                    >
                                      {!collapsed && i18n("Company.Info")}
                                    </span>
                                  </div>

                                  <div
                                    className={`text-colLightGray text-sm font-normal my-4 ${language === "ARABIC" && "text-start"}`}
                                    onClick={(e) => {
                                      if (canUserAccessTab("users")) {
                                        e.preventDefault();
                                        setCollapsed(true);
                                        setComapnyDropdownOpen(false);
                                        history.push("/management/users");
                                      }
                                    }}
                                  >
                                    <span
                                      className={`text-sm ${!canUserAccessTab("users") ? "text-colGrayLight cursor-default" : "cursor-pointer"
                                        }`}
                                    >
                                      {i18n("Company.Users")}
                                    </span>
                                  </div>
                                  <div style={isTrialExpired || isSubscriptionPaused ? { pointerEvents: "none" } : {}}
                                    className={`text-colLightGray text-sm font-normal my-4 ${language === "ARABIC" && "text-start"}`}
                                    onClick={(e) => {
                                      if (canUserAccessTab("roles")) {
                                        e.preventDefault();
                                        setCollapsed(true);
                                        setComapnyDropdownOpen(false);
                                        history.push("/management/roles");
                                      }
                                    }}
                                  >
                                    <span
                                      // className={`text-colLightGray text-sm font-normal"
                                      // }`}
                                      className={`text-sm ${isTrialExpired || isSubscriptionPaused || !canUserAccessTab("roles") ? "text-colGrayLight cursor-default" : "cursor-pointer"
                                        }`}
                                    >
                                      {i18n("Company.Roles")}
                                    </span>
                                  </div>
                                  <div style={isTrialExpired || isSubscriptionPaused ? { pointerEvents: "none" } : {}}
                                    className={`text-colLightGray text-sm font-normal my-4 ${language === "ARABIC" && "text-start"}`}
                                    onClick={(e) => {
                                      if (canUserAccessTab("sites")) {
                                        e.preventDefault();
                                        setCollapsed(true);
                                        setComapnyDropdownOpen(false);
                                        history.push("/management/sites");
                                      }
                                    }}
                                  >
                                    <span
                                      className={`text-sm ${isTrialExpired || isSubscriptionPaused || !canUserAccessTab("sites") ? "text-colGrayLight cursor-default" : "cursor-pointer"
                                        }`}
                                    >
                                      {i18n("Company.Sites")}
                                    </span>
                                  </div>
                                  <div
                                    className={`text-colLightGray text-sm font-normal ${language === "ARABIC" && "text-start"}`}
                                    onClick={(e) => {
                                      if (canUserAccessTab("subscription")) {
                                        e.preventDefault();
                                        setCollapsed(true);
                                        setComapnyDropdownOpen(false);
                                        history.push("/management/subscriptions");
                                      }
                                    }}
                                  >
                                    <span
                                      className={`text-sm ${!canUserAccessTab("subscription") ? "text-colGrayLight cursor-default" : "cursor-pointer"
                                        }`}
                                    >
                                      {i18n("Company.Subscriptions")}
                                    </span>
                                  </div>
                                </>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    ) : null}
                    {currentRole !== "user" && rolesAccess?.analytics?.selected ? (
                      // Analytics is always visible (Free / trial-expired / paused users
                      // still see the entry as an upgrade hook). When locked, the click
                      // opens the PremiumFeatureDialog instead of navigating.
                      (() => {
                        const analyticsLocked =
                          subscriptionData?.currentPlan?.plan === "Free" ||
                          isTrialExpired ||
                          isSubscriptionPaused;
                        const lockedStyle = {
                          color: "#C8C8C8",
                          textDecoration: "none",
                        };
                        return (
                          <div
                            className={`cursor-pointer ${window.location.href.indexOf("/analytics") > -1 ? "active" : ""}`}
                          >
                            {canAccessTheModule(
                              rolesAccess?.analytics?.selected,
                              analyticsLocked ? (
                                <button
                                  type="button"
                                  onClick={() => {
                                    setShowAnalyticsUpgrade(true);
                                    setCollapsed(true);
                                  }}
                                  className="w-full text-left bg-transparent border-0 p-0 focus:outline-none"
                                  style={lockedStyle}
                                >
                                  <div
                                    className={`${collapsed ? "flex justify-center items-center min-h-[40px]" : "flex items-center gap-3 min-h-[40px]"}`}
                                  >
                                    <img
                                      src={analyticsIcon}
                                      alt="IconAnalytics"
                                      className="w-5 h-5 shrink-0 opacity-40 grayscale"
                                    />
                                    {!collapsed && (
                                      <span
                                        className="font-semibold text-sm"
                                        style={{ color: "#bdbec6" }}
                                      >
                                        {i18n("Analytics.Analytics")}
                                      </span>
                                    )}
                                  </div>
                                </button>
                              ) : (
                                <Link
                                  to="/analytics"
                                  onClick={() => {
                                    getSession();
                                    setCollapsed(true);
                                  }}
                                >
                                  <div
                                    className={`${collapsed ? "flex justify-center items-center min-h-[40px]" : "flex items-center gap-3 min-h-[40px]"}`}
                                  >
                                    <img
                                      src={analyticsIcon}
                                      alt="IconAnalytics"
                                      className="w-5 h-5 shrink-0"
                                    />
                                    {!collapsed && (
                                      <span className="font-semibold text-sm">
                                        {i18n("Analytics.Analytics")}
                                      </span>
                                    )}
                                  </div>
                                </Link>
                              )
                            )}
                          </div>
                        );
                      })()
                    ) : null}
                    {user && isAuthenticated ? (
                      <React.Fragment>
                        <div className="user-avatar w-full bg-background">
                          <div onClick={toggle} className="w-full cursor-pointer outline-none border-none ">
                            <div
                              className={`flex items-center gap-2 ${collapsed ? "mx-3" : ""} min-h-[40px] ${collapsed ? "justify-center" : ""
                                } relative`}
                            >
                              <span onClick={toggleUserPopover}>
                                {user.profileImage ? (
                                  <img src={user.profileImage} alt="User Avatar" className="w-5 h-5 rounded-[50%]" />
                                ) : (
                                  <img src={userIcon} alt="userIcon" className="w-5 h-5 rounded-[50%]" />
                                )}
                              </span>
                              {!collapsed && (
                                <div className="flex justify-between items-center w-full">
                                  <span className="font-semibold text-sm text-colLightGray">
                                    {i18n("global.Hello")} {user.firstName}
                                  </span>
                                  <span>
                                    <img
                                      src={dropdown}
                                      alt="dropdown"
                                      className={`transition-transform duration-300 ${dropdownOpen ? "rotate-180" : ""}`}
                                    />
                                  </span>
                                </div>
                              )}
                              {collapsed && userPopoverOpen && userPopoverContent}
                            </div>
                          </div>
                        </div>

                        <div
                          className={`${language === "ARABIC"
                            ? "ml-12 mr-[30px] flex flex-col gap-5 cursor-pointer items-start"
                            : "mx-12 flex flex-col gap-5 cursor-pointer"
                            } `}
                        >
                          {dropdownOpen && !collapsed && (
                            <>
                              {(currentRole === "admin" || currentRole === "superAdmin" ||
                                (currentRole === "user" && !user.paymentPlan) ||
                                currentRole === "user" ||
                                (currentRole === "manager" && !user.paymentPlan)) && (
                                  <div
                                    className="text-colLightGray text-sm font-normal"
                                    onClick={(e) => {
                                      history.push("/company-user-profile");
                                      setCollapsed(true);
                                      setDropdownOpen(false);
                                    }}
                                  >
                                    <span>{i18n("global.Settings")}</span>
                                  </div>
                                )}

                              <div className="text-colLightGray text-sm font-normal cursor-pointer" onClick={() => window.open("https://help.tamamplus.com/help", "_blank")}>
                                <span>{i18n("global.Help")}</span>
                              </div>

                              <div className="text-colLightGray text-sm font-normal cursor-pointer" onClick={() => setIsModalOpen(true)}>
                                <span>{i18n("global.Logout")}</span>
                              </div>
                            </>
                          )}
                        </div>
                        {isModalOpen && (
                          <Dialog
                            title={<I18n lng="global.LogoutText" />}
                            onCancel={() => setIsModalOpen(false)}
                            onClose={() => setIsModalOpen(false)}
                            onSave={() => {
                              setCollapsed(true);
                              localStorage.setItem("language", user?.language ? user?.language : "ARABIC");
                              logout();
                              history.push("/login");
                            }}
                            saveButtonTitle={<I18n lng="global.Logout" />}
                            cancelButtonTitle={<I18n lng="global.Cancel" />}
                            showSaveButton={true}
                            showCloseIcon={false}
                            open={isModalOpen}
                            buttonAlignment="evenly"
                            titleClasses="!justify-center"
                          ></Dialog>
                        )}
                      </React.Fragment>
                    ) : null}
                  </nav>
                </div>
              </div>
              {user && isAuthenticated ? <div className="notification cursor-pointer" onClick={() => setOpenNotification(true)}></div> : null}
            </nav>
          </div>
        </header>
      )}
      {user && isAuthenticated && user.isEmailVerified && user.company ? (
        <div className="container" style={{ display: "none" }}>
          <nav>
            <div>
              <a href="#">{<I18n lng="global.InspectorPortal" />}</a>
            </div>
            {currentRoute.step1 ? (
              <div>
                <a href="#">{currentRoute.step1}</a>
              </div>
            ) : null}
            {currentRoute.step2 ? (
              <div>
                <a href="#">{currentRoute.step2}</a>
              </div>
            ) : null}
          </nav>
        </div>
      ) : null}

      {/* Keep the dialog mounted so the Drawer's
          `transition-transform duration-300 ease-out` actually runs on
          isOpen false -> true. Previously this was wrapped in
          `{openNotification && (...)}` which mounted the dialog only
          when the bell was clicked, so the drawer started in its open
          position without a transition. The internal useEffect already
          guards `if (showDlg)` so notifications are only fetched when
          the drawer actually opens — no perf cost from being mounted. */}
      <NotificationsDialog
        showDlg={openNotification}
        allNotifications={allNotifications}
        markedAsReadHandle={markedAsReadHandle}
        markedReadSingleHandler={markedReadSingleHandler}
        secondaryAction={() => setOpenNotification(false)}
        user={user}
      />

      {showUpdateSuccessModal && (
        <PlanDialog
          setShowDetailsDialog={setShowDetailsDialog}
          showModal={showUpdateSuccessModal}
          onClose={() => setShowUpdateSuccessModal(false)}
          modalTitle={updatePlanData.title}
          text_one={updatePlanData.text_one}
          text_two={updatePlanData.text_two}
          secondaryButtonLabel={updatePlanData.closeButtonText}
        />
      )}

      {showUpdatePlanModal && (
        <PlanDialog
          StartFreeTrialHandler={StartFreeTrialHandler}
          subscriptionId={subscriptionData?.id}
          isTrialStarted={subscriptionData?.currentPlan?.isTrialStarted}
          showModal={showUpdatePlanModal}
          onClose={closeUpdatePlanModal}
          modalTitle={modalData?.title}
          text_one={modalData?.text_one}
          text_two={modalData?.text_two}
          primaryButtonLabel={modalData?.actionButtonText}
          secondaryButtonLabel={modalData?.closeButtonText}
        />
      )}

      {showPricingPlanModal && (
        <PricingPlanDialog
          subscriptionData={subscriptionData}
          showModal={showPricingPlanModal}
          onClose={() => {
            setShowPricingPlanModal(false);
          }}
          text_one={pricingPlanModalData.text_one}
          text_two={pricingPlanModalData.text_two}
          text_three={pricingPlanModalData.text_three}
          modalTitle={pricingPlanModalData.title}
          primaryButtonLabel={pricingPlanModalData.actionButtonText}
          secondaryButtonLabel={pricingPlanModalData.closeButtonText}
          setChargeBillingDetailsDailog={setChargeBillingDetailsDailog}
          setSelectedPlan={setSelectedPlan}
          selectedPlan={selectedPlan}
        />
      )}

      {showResumeSubscriptionModal && (
        <PlanDialog
          cancelSubscription={hanldeResumeSubscription}
          showModal={showResumeSubscriptionModal}
          onClose={() => setShowResumeSubscriptionModal(false)}
          modalTitle={resumeSubscriptionModalData.title}
          text_one={resumeSubscriptionModalData.text_one}
          secondaryButtonLabel={resumeSubscriptionModalData.closeButtonText}
          secondaryButtonColor="#828282"
          primaryButtonColor="#20639B"
          primaryButtonLabel={resumeSubscriptionModalData.actionButtonText}
        />
      )}

      <ChargeBillingDetails
        subscriptionData={subscriptionData}
        show={chargeBillingDetailsDailog}
        onHide={() => setChargeBillingDetailsDailog(false)}
        selectedPlan={selectedPlan}
        setSelectedPlan={setSelectedPlan}
      />

      {showAnalyticsUpgrade && (
        <PremiumFeatureDialog
          subscriptionData={subscriptionData}
          onClose={() => setShowAnalyticsUpgrade(false)}
          onTrialStart={handleStartTrialFromAnalytics}
          onSubscribe={handleSubscribeFromAnalytics}
        />
      )}
    </>
  );
};

const mapStateToProps = ({ form, authentication, notifications, subscription }) => ({
  user: authentication.user,
  currentRole: authentication.currentRole,
  storedOldForm: form.storedOldForm,
  currentRoute: authentication.currentRoute,
  rolesAccess: authentication.userRoleAccess,
  isAuthenticated: authentication.isAuthenticated,
  allNotifications: notifications.allNotifications,
  unreadCount: notifications.unreadCount,
  subscriptionData: subscription.subscriptionData,
});

const mapDispatchToProps = {
  logout,
  getForm,
  getForms,
  patchForm,
  patchFormForNotification,
  changeCurrentRole,
  getAllNotifications,
  notificationReadSingle,
  notificationMarkedAsRead,
  updateSubscriptionData,
  getSubscriptionByCompanyId,
  getSession,
};

export default connect(mapStateToProps, mapDispatchToProps)(AppHeader);
